var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('click',{staticClass:"view-counter",attrs:{"callback":_vm.increment}},[(_vm.shouldRenderLabel)?_c('span',{staticClass:"view-counter-label"},[_vm._v(_vm._s(_vm.label)+": ")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"view-counter-value"},[_vm._v(_vm._s(_vm.valueToRender))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0caf6ce8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/counters/Counter.vue
// module id = 287
// module chunks = 0